var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "d-flex flex-wrap",
        class: { "flex-column": _vm.viewStyle === "list" }
      },
      _vm._l(_vm.dataShortcut, function(val, index) {
        return _c(
          "div",
          {
            key: index,
            class:
              "" +
              (_vm.viewStyle === "list"
                ? "list-of-shortcut"
                : "grid-of-shortcut")
          },
          [
            _c("img", { attrs: { src: val.icon } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(val.title))])
          ]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-195dc45c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-195dc45c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-card/jShortcutPageWidget.vue
// module id = null
// module chunks = 